import i18n from '/src/plugins/i18n'
import { reactive } from 'vue'
import StrapiService from '@/services/StrapiService'
import { Settings } from '@/store/index.js'

class InitialisationError extends Error {
  constructor (message, originalError) {
    super(message)
    this.name = 'InitialisationError'
    this.originalError = originalError

    // Ensure the correct stack trace is captured
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor)
    } else {
      this.stack = (new Error(message)).stack
    }
  }
}

class LocalesService {
  constructor () {
    this.languages = reactive({
      available: []
    })
    this.loadedLocales = new Set()
  }

  async init(lang = 'en') {
    try {
      await this.refreshAvailableLocales()
      await this.setAppLanguage(lang)
    } catch (e) {
      throw new InitialisationError('Failed to fetch translations', e)
    }
  }

  async setAppLanguage(lang) {
    // Ensure the language is supported, else fallback to English
    if (!this.languages.available.some(l => l.code === lang)) {
      // Avoid infinite loop
      if (Settings.getLanguage() !== 'en') {
        await Settings.setLanguage('en')
        return
      }
    }

    // Load translations if not already loaded
    if (!this.loadedLocales.has(lang)) {
      await this.loadAppTranslations(lang)
    }

    i18n.global.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
  }

  getAppLanguage() {
    return i18n.global.locale
  }

  async loadAppTranslations(locale) {
    const { data: at } = await StrapiService.getContentType('translations', {
      fields: ['key', 'value', 'locale'],
      locale
    })

    // this.updateSupportedLocales([locale])

    // Add content translations
    const messages = at.data
      .filter(tr => tr.attributes.locale === locale)
      .reduce((messages, tr) => {
        messages[tr.attributes.key] = tr.attributes.value
        return messages
      }, {})

    i18n.global.setLocaleMessage(locale, messages)
    // i18n.mergeLocaleMessage(locale, messages)

    this.loadedLocales.add(locale)
  }

  async refreshAvailableLocales() {
    const { data: locales } = await StrapiService.getAvailableLocales()

    const languages = locales.map(tr => ({
      code: tr.attributes.code,
      name: tr.attributes.name
    }))

    this.updateSupportedLocales(languages)
  }
  updateSupportedLocales(locales) {
    locales
      .filter(l => !this.languages.available.some(al => al.code === l.code))
      .forEach(l => this.languages.available.push(l))
  }
}

export default new LocalesService()
